export class TableEmptyState {
  /**
   * @var {string}
   */
  entityName;

  /**
   * @var {Function}
   */
  onClick;

  /**
   * @var {boolean}
   */
  showActionButton;

  constructor(entityName = null, onClick = null) {
    this.entityName = entityName ? entityName.toLowerCase() : null;
    this.onClick = onClick;
    this.showActionButton = !!onClick;
  }
}
